import { Alert, Button } from '@arco-design/web-react';
import type { FormSessionToken } from '@jukun/platform-sdk/shell';
import { PortalFormSessionHost } from '../../../components/PortalFormSessionHost';
import type { PortalApplication, PortalIdentity } from '../../../model/portalModels';
import type { PortalInitiatedInstanceDetail } from '../model/myTasks';

/** A read-only display lease; no source application lifecycle or writable Bridge is owned here. */
export function InitiationViewFormHost(props: {
  detail: PortalInitiatedInstanceDetail; token?: FormSessionToken; sourceFailure?: unknown;
  applications: PortalApplication[]; identity: PortalIdentity;
  onSessionExpired: () => void; onRetry: () => void;
}) {
  return <div className="portal-work-item-form-host">
    {props.sourceFailure && !props.token ? <Alert type="error" title="启动表单暂不可用"
      content="流程实例信息和评论仍可查看。"
      action={<Button type="primary" size="small" onClick={props.onRetry}>重新加载</Button>} />
      : <PortalFormSessionHost token={props.token} onRetry={props.onRetry}
        className="portal-work-item-form-host__container" />}
  </div>;
}
